import { render, staticRenderFns } from "./task_info.vue?vue&type=template&id=c7e5d2f8&scoped=true"
import script from "./task_info.vue?vue&type=script&lang=js"
export * from "./task_info.vue?vue&type=script&lang=js"
import style0 from "./task_info.vue?vue&type=style&index=0&id=c7e5d2f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e5d2f8",
  null
  
)

export default component.exports